import * as React from 'react';

import classes from './RadioGroup.scss';

type Props = {
  name: string;
  className?: string;
  children: React.ReactNode;
  role?: React.AriaRole;
};

export const RadioGroupContext = React.createContext<{ name: string } | null>(null);

const RadioGroup: React.FC<Props> = ({ name, className, children, role = 'radiogroup' }) => {
  const classNames = [classes['radioGroup'], className].filter(Boolean).join(' ');

  return (
    <div
      className={classNames}
      role={role}
    >
      <RadioGroupContext.Provider value={{ name }}>{children}</RadioGroupContext.Provider>
    </div>
  );
};

export default RadioGroup;
